/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Badge } from 'antd'
import { Heart, PaperPlaneTilt, User } from 'phosphor-react'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import * as s from './BottomNavigation.styles'

const BottomNavigation = ({ setIsProfileOpen }) => {
  const location = useLocation()

  const { likes } = useSelector((state) => state.talent)
  const { matchingOffers } = useSelector((state) => state.talent)

  return (
    <s.BottomNavigationWrapper>
      <div className="tab-container">
        {/* TODO: hide home for now */}
        {/* <Link to="/app/home">
          <div
            className={
              location.pathname === '/app/home' ? 'tab active' : 'tab inactive'
            }
          >
            <FontAwesomeIcon icon={faHome} />
          </div>
        </Link> */}

        <Link to="/app/jobs">
          <Badge
            // count={
            //   likes.pending.filter((el) => el.userStatus === 'approved').length
            // }
            count={matchingOffers.length + likes.pending.length}
            // if location is jobs, turn badge to white
            style={{
              right: 20,
              backgroundColor:
                location.pathname === '/app/jobs' ? '' : '#eb5b56',
            }}
          >
            <div
              className={
                location.pathname === '/app/jobs'
                  ? 'tab active'
                  : 'tab inactive'
              }
            >
              <PaperPlaneTilt size={25} weight="light" />
            </div>
          </Badge>
          <div
            className={
              location.pathname === '/app/jobs'
                ? 'text active'
                : 'text inactive'
            }
          >
            <p>Suggestions</p>
          </div>
        </Link>
        <Link to="/app/applications">
          <div
            className={
              location.pathname === '/app/applications'
                ? 'tab active'
                : 'tab inactive'
            }
          >
            <Heart size={25} weight="light" />
          </div>
          <div
            className={
              location.pathname === '/app/applications'
                ? 'text active'
                : 'text inactive'
            }
          >
            <p>Candidatures</p>
          </div>
        </Link>
        <Link to="/app/profile">
          <div
            className={
              location.pathname === '/app/profile'
                ? 'tab active'
                : 'tab inactive'
            }
          >
            <User size={25} weight="light" />
          </div>
          <div
            className={
              location.pathname === '/app/profile'
                ? 'text active'
                : 'text inactive'
            }
          >
            <p>Mon profil</p>
          </div>
        </Link>
      </div>
    </s.BottomNavigationWrapper>
  )
}

export default BottomNavigation
